'use client';

import Link from 'next/link';
import { Button, Flex, Stack, Text, Title, useMantineTheme } from '@mantine/core';

export default function Hero() {
  const theme = useMantineTheme();

  return (
    <Stack gap="md" align="center" mb="lg">
      <Title order={1} ta="center" size="h1" lh={1.1} ff={theme.other.accentFontFamily}>
        <Text
          component="span"
          inherit
          variant="gradient"
          gradient={{ from: 'violet.5', to: 'orange.5', deg: 135 }}
        >
          Добро пожаловать в Синтра
        </Text>
      </Title>

      <Text size="xl" fw={500} c="dimmed" ta="center">
        Корпоративный портал нового поколения
      </Text>

      <Text size="md" fw={600} c="violet" fs="italic" ta="center">
        "Будущее уже здесь"
      </Text>

      <Text size="md" c="dimmed" ta="center" maw="37.5rem" lh={1.6}>
        Единая точка входа для работы с информацией, обучением, документами и поддержкой.
        Современный интерфейс, удобная навигация и все необходимые инструменты для эффективной работы.
      </Text>

      <Flex
        mt="md"
        gap="md"
        justify="center"
        align="center"
        direction={{ base: 'column', xs: 'row' }}
        w="100%"
      >
        <Button
          component={Link}
          href="/login"
          size="lg"
          variant="gradient"
          gradient={{ from: theme.other.brandAccentStart, to: theme.other.brandAccentEnd, deg: 135 }}
          px="xl"
          fullWidth
          maw={{ base: '100%', xs: 'fit-content' }}
        >
          Начать работу
        </Button>

        <Button
          component={Link}
          href="/register"
          size="lg"
          variant="default"
          px="xl"
          fullWidth
          maw={{ base: '100%', xs: 'fit-content' }}
        >
          Зарегистрироваться
        </Button>
      </Flex>
    </Stack>
  );
}
